import './styles.scss';

export { Modal } from './Modal';
export { ModalPopup } from './Popup';
export { ModalUpgrade } from './Upgrade';



// WEBPACK FOOTER //
// ./src/components/Modal/index.js